import ModalComponent from "..";
import { useDeleteEventMutation } from "../../../redux/features/event/event.api";
import { CreatedEvent } from "../../../redux/features/event/event.types";
import { ModalCompProps } from "../../../utils/types";
import { Button } from "../../buttons/button";
import { Icon } from "../../icon/icon";
import { MiniHeader } from "../../typography/miniHeader";

export const DeleteEventModal = ({
  open,
  handleClose,
  event,
  onSuccess,
}: ModalCompProps & {
  event: CreatedEvent;
  onSuccess: () => void;
}) => {
  const [deleteEvent, { isLoading }] = useDeleteEventMutation();

  return (
    <ModalComponent
      open={open}
      handleClose={() => {
        handleClose();
      }}
      className=""
      dialogClassName=""
      closeOnOverlayClick
      showHeader={false}
      title={undefined}
      subtitle={undefined}
      showBackIcon={false}
      mobileAnchorBottom
      showCloseIcon={false}
    >
      <div className="flex flex-col gap-4">
        <Icon
          svg={"bin-2"}
          width={42}
          height={42}
          className="rounded-xl border border-grey-100 p-[11px] text-danger"
        />

        <div>
          <MiniHeader
            header={`Delete “${event.name}” Draft`}
            subheader="Are you sure you want to delete this draft? Once you do, you won’t be able to get it back."
          />
        </div>

        <div className="flex w-full items-center justify-end gap-2">
          <Button
            text={"Cancel"}
            type="button"
            onClick={() => {
              handleClose();
            }}
            variation="plain-grey"
            className="max-w-fit"
          />
          <Button
            text={"Delete Draft"}
            type="submit"
            onClick={async () => {
              const resp = await deleteEvent({
                id: event._id,
              });

              if (resp?.data?.status === "success") {
                onSuccess();
              }
            }}
            className="max-w-fit"
            loading={isLoading}
            disabled={isLoading}
            variation={"danger"}
          />
        </div>
      </div>
    </ModalComponent>
  );
};
